import React from 'react';
import { MathJaxRenderer } from '../../components/math-renderers';
import { QuestionContent } from '../../utils/myTestApi';

/**
 * A question's image (most WiZi questions are images), else its text. The
 * options are drawn by the caller, because taking a test and reading a
 * result draw them differently.
 */
export const QuestionBody: React.FC<{ content: QuestionContent | null }> = ({ content }) => {
  if (!content) {
    return <div className="alert alert-warning mb-0">This question could not be loaded. Tell your teacher.</div>;
  }
  return (
    <>
      {content.question_img_url && (
        <img
          src={content.question_img_url}
          alt="Question"
          className="img-fluid mb-3"
          style={{ maxHeight: 400, objectFit: 'contain' }}
        />
      )}
      {!content.question_img_url && content.question_text && (
        <div className="mb-3 fs-5">
          <MathJaxRenderer>{content.question_text}</MathJaxRenderer>
        </div>
      )}
    </>
  );
};

/** The options that exist as text, as [value, letter, text]. Image-only questions have none. */
export const optionsOf = (content: QuestionContent | null): Array<[string, string, string | null]> => {
  if (!content) return [];
  const all: Array<[string, string, string | null]> = [
    ['1', 'A', content.option_a],
    ['2', 'B', content.option_b],
    ['3', 'C', content.option_c],
    ['4', 'D', content.option_d],
  ];
  return all.slice(0, content.option_count || 4);
};
